export default __webpack_public_path__ + "static/media/files-folders-sm-red.22cfc832.svg";